module.exports = __webpack_public_path__ + "static/media/deadwobster.1a1b9543.webp";